import { priceVatCalc, calcPrice, DataLayer } from '@grandvisionhq/analytics';

/**
 * Accepts an array of specification names and returns the first hit it finds or empty string
 * Example: ['materialUnlocalized', 'material'] -> returns unlocalized material value or fallbacks to material or empty string
 */ const getVariantSpecification = (specificationNames, variant)=>{
    for (const name of specificationNames){
        const spec1 = variant.specifications.find((spec)=>spec.specificationAttribute === name
        );
        if (spec1) {
            return spec1.value.toString().toLowerCase();
        }
    }
    return '';
};
const getSharedProductDetailEventTrackingAttributes = ({ activeVariant , product , displayPrice , purchaseType , lineItemType  })=>{
    var ref;
    const { DataLayerTypes: { Stock , BrandType , LineItemType  } ,  } = DataLayer;
    // metric140
    const originalPrice = displayPrice.originalPrice;
    const discountedPrice = displayPrice.discountedPrice;
    // metric142
    let metric142 = '';
    const vatRate = product.analyticsData.vatRate;
    if (vatRate) {
        const { vatAmount  } = discountedPrice ? priceVatCalc(discountedPrice, vatRate) : priceVatCalc(originalPrice, vatRate);
        metric142 = calcPrice(vatAmount, false);
    }
    // metric price
    const price = discountedPrice || originalPrice || undefined;
    // metric140
    const previousPrice = originalPrice || undefined;
    // metric141
    const discountedAmount = discountedPrice && originalPrice - discountedPrice || 0;
    // dimension190
    const erpId = getVariantSpecification([
        'erpId'
    ], activeVariant);
    // dimension193
    let dimension193 = '';
    if ('isExclusiveBrand' in product) {
        const isExclusiveBrand = product.isExclusiveBrand;
        dimension193 = isExclusiveBrand ? BrandType.OwnBrand : BrandType.ExternalBrand;
    }
    // dimension194
    const isInStock = ((ref = activeVariant.stock) === null || ref === void 0 ? void 0 : ref.stockCount) > 0;
    return {
        name: activeVariant.displayName,
        id: activeVariant.sku || '',
        price: calcPrice(price, false),
        dimension143: purchaseType,
        dimension144: lineItemType || LineItemType.Single,
        dimension145: 'true',
        dimension190: erpId,
        dimension193,
        dimension194: isInStock ? Stock.InStock : Stock.OutOfStock,
        metric140: calcPrice(previousPrice, false),
        metric141: calcPrice(discountedAmount, false),
        metric142
    };
};

export { getSharedProductDetailEventTrackingAttributes, getVariantSpecification };
//# sourceMappingURL=get-shared-product-detail-event-tracking-attributes.js.map
